import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';

import { getLocale } from '@/configuration/lang/langSlice';
import { useAppSelector } from '@/configuration/setup/hooks';

const AppHeader = () => {
    const userLocale = useAppSelector(getLocale);
    const environment = import.meta.env.PROD ? 'production' : 'local';

    const label = (
        <span>
            DEMO<span className="text-color-primary text-italic">FLEETPLAYER</span>
        </span>
    );

    const navItems = [
        {
            key: 'overview',
            route: (
                <NavLink to="/">
                    <FormattedMessage id="intl-msg:appHeader.nav.overview" />
                </NavLink>
            ),
        },
    ];

    const userMenu = <DefaultUserMenu environment={environment} locale={userLocale} key="user-menu" />;

    return <ApplicationHeader label={label} navItems={navItems} actionBarItems={[userMenu]} />;
};

export default AppHeader;
